/**
 * Binary search over integer font sizes for the largest one whose `measure`
 * result still fits inside `boxHeight`. `measure` is assumed non-decreasing
 * in `fontSize` (a bigger font never produces a smaller wrapped block).
 *
 * Returns `minFontSize` when even the minimum overflows the box — the
 * composition is expected to scale the whole text block down further in that
 * case, never truncate it.
 */
export function fitQuoteFontSize(args: {
  text: string;
  boxHeight: number;
  maxFontSize: number;
  minFontSize: number;
  measure: (fontSize: number) => number;
}): number {
  const {
    text, boxHeight, maxFontSize, minFontSize, measure,
  } = args;

  if (!text || measure(minFontSize) > boxHeight) return minFontSize;

  let lo = minFontSize;
  let hi = maxFontSize;
  let best = minFontSize;

  while (lo <= hi) {
    const mid = Math.floor((lo + hi) / 2);
    if (measure(mid) <= boxHeight) {
      best = mid;
      lo = mid + 1;
    } else {
      hi = mid - 1;
    }
  }

  return best;
}
